import React, { useContext, useEffect, useState } from "react";
import { ThemeProvider } from "@material-ui/core/styles";
import { initTheme } from "./theme/primary";
import PrimaryLayout from "../../layouts/PrimaryLayout";
import { useRouteMatch } from "react-router-dom";
import { GlobalContext } from "../../root/App";
import { CircularProgress, CssBaseline } from "@material-ui/core";
import SaleAppRoutes, { getSidebarRoutes } from "./routes/SaleAppRoutes";
import { getCookie } from "../../utils/cookies";
import { fetchAllLocations } from "../../services/locationApp/locationService";
import { getFilterListFromArrayObject } from "../../utils/commonArrayMap";
import { handleChangeRestaurant } from "../../utils";
import { SALE_QUERY_PARAMS } from "../../utils/consts";
import queryString from "query-string";
import firebase from "firebase";
import { createCustomToken } from "../../services/globalService";
import { verifyAuthTokenWithServer } from "../../services/accountApp/authService";

export interface PrestoExpressLocationAppProps {}

const PrestoExpressLocationApp: React.FunctionComponent<
  PrestoExpressLocationAppProps
> = () => {
  const [sidebarRoutes, setSidebarRoutes] = React.useState<any>([]);
  const [locations, setLocations] = useState<any>();
  const { globalState } = useContext(GlobalContext);
  const theme = initTheme({ isDark: globalState.isDarkMode });
  const match: any = useRouteMatch();

  const getLocationInfo = async () => {
    try {
      const idToken: any = getCookie("idToken");

      const res = await fetchAllLocations(idToken);
      const location = getFilterListFromArrayObject(
        res.data.data,
        match.params.locationId,
      );
      setLocations(res.data.data);
      handleChangeRestaurant(location[0]);
      handleChangeSidebar(res.data.data);
    } catch (error) {}
  };

  const handleChangeSidebar = (location?: any) => {
    const sidebar = getSidebarRoutes();
    const locationsList = location ? location : locations;
    if (locationsList.length < 2) {
      const sidebarList = sidebar.filter(
        (item: any) => item.id !== "SALES_BY_LOCATION_REPORT",
      );
      setSidebarRoutes(sidebarList);
    } else {
      setSidebarRoutes(sidebar);
    }
  };
  const tokens = queryString.parse(window.location.search).t;

  React.useEffect(() => {
    // Call the function to fetch location information
    if (!tokens) {
      getLocationInfo();
    }
  }, []);

  /**
   * Extracts the 'app' parameter from the query string in the window's location.
   * Uses the queryString library to parse the query string and retrieve the 'app' value.
   *
   * @constant {string} selectedApp - The value of the 'app' parameter from the query string.
   */
  const selectedApp = queryString.parse(window.location.search).app;
  const isAppEmbedded = queryString.parse(window.location.search).isAppEmbedded;
  const [isLoad, setIsLoad] = useState(false);

  function removeQueryParam(url: any, param: any) {
    var urlParts = url.split("?");
    if (urlParts.length >= 2) {
      var prefix = encodeURIComponent(param) + "=";
      var queryParams = urlParts[1].split(/[&;]/g);

      // Iterate through query parameters
      for (var i = queryParams.length; i-- > 0; ) {
        // Remove param if found
        if (queryParams[i].lastIndexOf(prefix, 0) !== -1) {
          queryParams.splice(i, 1);
        }
      }

      // Reconstruct the URL
      url =
        urlParts[0] +
        (queryParams.length > 0 ? "?" + queryParams.join("&") : "");
    }
    return url;
  }

  const handleRedirect = () => {
    let params = new URLSearchParams(window.location.search);

    // Delete the foo parameter.
    params.delete("t");

    // now join the query param and host
    var outputUrl = removeQueryParam(window.location.href, "t");

    const interval = setInterval(() => {
      const idToken = getCookie("idToken");
      if (idToken) {
        setIsLoad(true);
        window.location.href = outputUrl;
      }
    }, 500);

    return () => clearInterval(interval);
  };

  const handleLogin = (firebaseUser: any) => {
    firebaseUser.getIdToken(true).then((idToken: any) => {
      // Get the login details
      verifyAuthTokenWithServer(idToken, firebaseUser);
      handleRedirect();
    });
  };

  const handleAuthentication = async () => {
    try {
      const authFirebase = firebase.auth();

      const token = queryString.parse(window.location.search).t;
      const res = await createCustomToken(token);
      const customToken = res.data.customToken;
      const userCredential = await authFirebase.signInWithCustomToken(
        customToken,
      );
      if (userCredential) {
        handleLogin(userCredential);
      } else {
      }
    } catch {}
  };
  const token = queryString.parse(window.location.search).t;

  useEffect(() => {
    if (isAppEmbedded === "true") {
      if (token) {
        const onAuthStateChange = async () => {
          const authFirebase = firebase.auth();
          authFirebase.onAuthStateChanged((firebaseUser: any) => {
            if (firebaseUser) {
              handleLogin(firebaseUser);
            } else {
              handleAuthentication();
            }
          });
        };
        onAuthStateChange();
      } else {
        setIsLoad(true);
      }
    } else {
      setIsLoad(true);
    }
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <PrimaryLayout
        sidebarRoutes={sidebarRoutes}
        handleChangeSidebar={handleChangeSidebar}
      >
        {!isLoad ? (
          <div style={{ marginTop: "14%" }}>
            <CircularProgress color="secondary" disableShrink />
          </div>
        ) : (
          (sidebarRoutes.length > 0 ||
            selectedApp === SALE_QUERY_PARAMS ||
            token) &&
          (isAppEmbedded === "true" ? (
            <div style={{ margin: "0px 20px" }}>
              <SaleAppRoutes />
            </div>
          ) : (
            <SaleAppRoutes />
          ))
        )}
      </PrimaryLayout>
    </ThemeProvider>
  );
};

export default PrestoExpressLocationApp;
